<template>
  <el-dialog
    append-to-body
    width="900px"
    :title="title"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-descriptions
      v-loading="loading"
      :column="2"
      border
      class="custom-desc"
      style="margin-bottom: 10px"
      :label-style="{
        width: '100px',
        minWidth: '100px',
        maxWidth: '100px',
        flex: 'none',
      }"
    >
      <el-descriptions-item label="岗位名称">{{
        info.title
      }}</el-descriptions-item>
      <el-descriptions-item label="岗位类型">{{
        info.category_name
      }}</el-descriptions-item>
      <el-descriptions-item label="薪资">
        {{
          `${info.salary}元/${
            { 1: "小时", 2: "日", 3: "月" }[info.salary_type]
          }`
        }}
      </el-descriptions-item>
      <el-descriptions-item label="结算周期">{{
        `${
          { 1: "日结", 2: "周结", 3: "月结", 4: "项目结" }[
            info.part_settlement_type
          ]
        }`
      }}</el-descriptions-item>
      <el-descriptions-item label="学历">{{
        info.education_name
      }}</el-descriptions-item>
      <el-descriptions-item label="经验">{{
        info.work_age_name
      }}</el-descriptions-item>
      <el-descriptions-item label="联系人">{{
        info.create_name
      }}</el-descriptions-item>
      <el-descriptions-item label="联系电话">{{
        info.create_account
      }}</el-descriptions-item>
      <el-descriptions-item label="岗位要求">{{
        info.demand
      }}</el-descriptions-item>
      <el-descriptions-item label="工作内容">{{
        info.duty
      }}</el-descriptions-item>
      <el-descriptions-item label="创建时间" v-if="info.part_status > 1">{{
        info.create_time
      }}</el-descriptions-item>
      <el-descriptions-item label="审核时间" v-if="info.part_status > 1">
        <span>{{ info.part_check_time }}</span>
        <span style="margin-left: 10px">{{
          info.part_status == 3 ? "通过" : "拒绝"
        }}</span>
        <div v-if="info.part_status == 2">{{ info.part_refuse_reason }}</div>
      </el-descriptions-item>
    </el-descriptions>
    <div style="margin-bottom: 10px;display:flex;margin-left: 10px;">
       <div>
        <span>用工时间({{ { 1: "按日期", 2: "按星期" }[info.part_work_hour_type] }})</span>
        <span v-if="info.part_work_hour_type == 2 && info.part_week_over_time" style="margin-left:10px">用工截止时间: {{info.part_week_over_time}}</span>
        <span v-if="info.part_work_time_type == 2" style="margin-left:30px">要求全部时间到岗</span>
       </div>
    </div>
    <el-row style="margin-bottom: 10px">
      <el-col
        :span="6"
        v-for="(item, index) in info.part_work_hour"
        :key="index"
      >
        <el-card
          :class="{ 'back-ground': zhaoman(item) }"
          style="position: relative"
        >
          <div>
            <span style="margin-right: 10px">{{
              item.day ||
              {
                1: "每周一",
                2: "每周二",
                3: "每周三",
                4: "每周四",
                5: "每周五",
                6: "每周六",
                7: "每周天",
              }[item.week]
            }}</span
            ><span>{{ item.start_time }}-{{ item.end_time }}</span>
          </div>
          <div style="margin-top:6px">
            <span>{{ getHourMin(item.start_time, item.end_time) }}</span>
            <span style="margin-left: 12px">
              <span v-if="info.part_status == 3">{{ item.apply_total }}/</span>
              <span>{{ item.total }}人</span>
            </span>
          </div>
          <div class="z-m" v-if="zhaoman(item)" style="color: #fff">已招满</div>
        </el-card>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center" v-if="info.part_status == 1">
      <el-button type="primary" @click="toAgree">审核通过</el-button>
      <el-button type="danger" @click="toReject">审核拒绝</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
export default {
  name: "ReportDetail",
  data() {
    return {
      title: "",
      visible: false,
      loading: false,
      info: {},
    };
  },
  created() {},
  methods: {
    zhaoman(item) {
      return item.apply_total >= item.total;
    },
    getHourMin(startTime, endTime) {
      const [startHour, startMinute] = startTime.split(":").map(Number);
      const [endHour, endMinute] = endTime.split(":").map(Number);

      let totalStartMinutes = startHour * 60 + startMinute;
      let totalEndMinutes = endHour * 60 + endMinute;

      // 处理跨天情况
      if (totalEndMinutes < totalStartMinutes) {
        totalEndMinutes += 24 * 60;
      }

      const diffMinutes = totalEndMinutes - totalStartMinutes;
      const hours = Math.floor(diffMinutes / 60);
      const minutes = diffMinutes % 60;

      // return { hours, minutes };
      return `${hours}小时${minutes}分钟`;
    },
    getDetail(row, title) {
      this.title = title;
      this.init(row);
    },
    init(row) {
      this.loading = true;
      this.$http
        .get("/admin/job/detail", { params: { id: row.id } })
        .then((res) => {
          if (res.code == 1) {
            this.info = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    toAgree() {
      this.$confirm(
        `<div>岗位:${this.info.title}</div><div style="margin-top:10px">审核通过并发布兼职岗位</div>`,
        "同意",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          center: true,
        }
      ).then(() => {
        this.$http
          .post("/admin/job/checkPart", { id: this.info.id, part_status: 3 })
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.toggle(false);
              this.$emit("update");
            }
          });
      });
    },
    toReject() {
      this.$prompt(`岗位:${this.info.title}`, "驳回", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S+/,
        inputErrorMessage: "请输入驳回原因",
        inputPlaceholder: "请输入驳回原因",
        center: true,
      }).then(({ value }) => {
        this.$http
          .post("/admin/job/checkPart", {
            id: this.info.id,
            part_status: 2,
            reason: value,
          })
          .then((res) => {
            if (res.code == 1) {
              this.$message.success("操作成功");
              this.toggle(false);
              this.$emit("update");
            }
          });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.custom-desc {
  width: 100%;
}
.back-ground {
  background-color: #c4c4c4;
}
.z-m {
  position: absolute;
  bottom: 0;
  right: 0;
  color: red;
}
</style>